import React, { useState } from 'react'
import PropTypes from 'prop-types'

import SelectInputOptionsModal from '../SelectInputOptionsModal'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import SelectableInput from '../SelectableInput'

export default function SelectInput (props) {
  const {
    name, label, selected, keyProp, nameProp, getOptionLabel, onChange, icon,
    options, placeholder, multiselect, loading, filterAsync, error, readonly,
    pagination, noMoreOptions, loadMore, globalLoading, testID
  } = props

  const [openSelectModal, setOpenSelectModal] = useState(false)
  const { theme } = useTheme()

  const onCloseSelectModal = (newSelected) => {
    setOpenSelectModal(false)
    onChange(name, newSelected)
  }

  const getInputValue = () => {
    if (multiselect) {
      return selected ? selected.map(option => getOptionLabel ? getOptionLabel(option) : option[nameProp]).join(', ') : ''
    } else {
      return selected ? (getOptionLabel ? getOptionLabel(selected) : selected[nameProp]) : ''
    }
  }

  return (
    <>
      <SelectableInput
        label={label}
        value={getInputValue()}
        icon={icon}
        rightIcon={
          <Icon
            name='FilterArrow'
            height={10}
            width={10}
            fill={theme.SLATE_GRAY}
          />
        }
        placeholder={placeholder}
        onPress={() => setOpenSelectModal(true)}
        error={error}
        readonly={readonly}
        testID={testID}
      />
      <SelectInputOptionsModal
        selected={selected}
        open={openSelectModal}
        placeholder={placeholder}
        options={options}
        keyProp={keyProp}
        nameProp={nameProp}
        onClose={onCloseSelectModal}
        multiselect={multiselect}
        loading={loading}
        filterAsync={filterAsync}
        getOptionLabel={getOptionLabel}
        pagination={pagination}
        noMoreOptions={noMoreOptions}
        loadMore={loadMore}
        globalLoading={globalLoading}
      />
    </>
  )
}

SelectInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.any,
  keyProp: PropTypes.string,
  nameProp: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  loading: PropTypes.bool,
  filterAsync: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  getOptionLabel: PropTypes.func,
  readonly: PropTypes.bool,
  pagination: PropTypes.bool,
  noMoreOptions: PropTypes.bool,
  loadMore: PropTypes.func,
  globalLoading: PropTypes.bool,
  testID: PropTypes.string
}

SelectInput.defaultProps = {
  name: '',
  label: '',
  selected: null,
  keyProp: '',
  nameProp: '',
  placeholder: '',
  icon: '',
  options: [],
  style: null,
  onChange: () => {},
  multiselect: false,
  loading: false,
  filterAsync: null,
  error: '',
  getOptionLabel: null,
  readonly: false,
  pagination: false,
  noMoreOptions: false,
  loadMore: null,
  globalLoading: false,
  testID: null
}
